import { atom } from 'recoil';
import { IEmpresa } from '../../commons/types/crm';


export const empresasAtom = atom<IEmpresa[]>({
  key: 'empresas', 
  default: [] as IEmpresa[],
}); 
